import { css } from '@/styled-system/css';

// Auto-flow rather than `repeat(n, …)`: the track count is a runtime prop, and Panda
// extracts styles statically — an interpolated repeat() would emit no rule at all.
// Implicit columns size themselves the same way for any number of boxes.
export const codeGrid = css({
  display: 'grid',
  gridAutoFlow: 'column',

  gridAutoColumns: 'minmax(0, 56px)',
  gap: 'tighter',
  justifyContent: 'center',
});

export const codeInputBox = css({
  textAlign: 'center',
  // Input's default 16px inline padding leaves almost no room for the character once
  // the track shrinks on narrow screens.
  paddingInline: 'tightest',
});
